
import { useState } from "react";
import { PatientVisit } from "../../amplify/appsync/search-patients";
import './ChiefComplaint.scss';
import { ReasonsForVisitModal } from "./ReasonsForVisitModal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const ChiefComplaint = (props: {
    patientVisit: PatientVisit,
}) => {

    const [showModal, setShowModal] = useState<boolean>(false);

    return (
        <>
            <OverlayTrigger
                placement="bottom"
                overlay={
                    <Tooltip>
                        Show Reasons for Visit
                    </Tooltip>
                }
            >
                <span className="chief-complaint" onClick={() => {setShowModal(true)}}>{props.patientVisit.chief_complaint}</span>
            </OverlayTrigger>
            <ReasonsForVisitModal patientVisit={props.patientVisit} showModal={showModal} setShowModal={setShowModal} />
        </>
    );
};
